<script type="text/jsx">
    export default {
        functional: true,
        inject: {
          val: {
              from: "jds.test.provide1",
              default () {
                  return () => 'default'
              }
          }
        },
        render(h, context) {
            return <div>
                Value1: { context.injections.val() }
            </div>
        },
    }
</script>
